import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './App';
import { store } from "./app/store";
import { Provider } from "react-redux";
import { ToastContainer } from "react-toastify";
import { PrimeReactProvider } from 'primereact/api';
import './index.scss';
import "react-toastify/dist/ReactToastify.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";


const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <PrimeReactProvider value={{ unstyled: false, }}  >
      <Provider store={store}>
        <ToastContainer autoClose={3000} />
        <App />
      </Provider>
    </PrimeReactProvider>
  </React.StrictMode>
);
reportWebVitals();
